import PercentageOfTotal from "./PercentageOfTotal";

export default PercentageOfTotal;
